import React, { useState } from 'react';
import { 
    FiArrowLeft, FiPlus, FiStar, FiTool, FiZap, 
    FiTrendingUp, FiEdit2, FiUsers 
} from 'react-icons/fi';
import "../../../styles/Header-css/ServicePartner/PartnerProfile/MyServices.css";

const MyServices = () => {
    const [isPlumberActive, setIsPlumberActive] = useState(true);
    const [isElectricianActive, setIsElectricianActive] = useState(true);

    const handleAddServicesClick = () => {
        alert('Add Services button clicked!');
    };

    const handleEditPriceClick = () => {
        alert('Edit price button clicked!');
    };

    const handleBrowseServicesClick = () => {
        alert('Browse Available Services clicked!');
    };

    const handleToggle = (serviceName, currentStatus, setStatus) => {
        const newStatus = !currentStatus;
        setStatus(newStatus);
        const statusText = newStatus ? 'activated' : 'deactivated';
        console.log(`${serviceName} service has been ${statusText}.`);
    };

    return (
        <div className="services-container">
            {/* Page Header */}
            <header className="services-header">
                <div className="header-left">
                    <button className="back-btn"><FiArrowLeft /></button>
                    <h1>My Services</h1>
                </div>
                <button className="btn btn-primary add-services-btn" onClick={handleAddServicesClick}>
                    <FiPlus />
                    <span>Add Services</span>
                </button>
            </header>

            {/* Top Stats Bar */}
            <section className="stats-bar">
                <div className="stat-item">
                    <span className="stat-value">2</span>
                    <span className="stat-label">Active Services</span>
                </div>
                <div className="stat-item">
                    <span className="stat-value">77</span>
                    <span className="stat-label">Total Jobs</span>
                </div>
                <div className="stat-item">
                    <FiStar className="star-icon" />
                    <span className="stat-value">4.8</span>
                    <span className="stat-label">Avg Rating</span>
                </div>
            </section>

            {/* Main Content Grid for Service Cards */}
            <main className="services-grid">
                {/* Service Card: Plumber */}
                <article className="service-card">
                    <div className="card-header">
                        <div className="service-title">
                            <FiTool />
                            <h2>Plumber</h2>
                        </div>
                        <div className="toggle-switch">
                            <input 
                                type="checkbox" 
                                id="plumber-toggle" 
                                className="toggle-input" 
                                checked={isPlumberActive}
                                onChange={() => handleToggle('plumber', isPlumberActive, setIsPlumberActive)}
                            />
                            <label htmlFor="plumber-toggle" className="toggle-label"></label>
                        </div>
                    </div>

                    <div className="card-stats">
                        <div className="card-stat-item">
                            <FiStar />
                            <span><strong>4.8</strong> Rating</span>
                        </div>
                        <div className="card-stat-item">
                            <FiUsers />
                            <span><strong>45</strong> Job Done</span>
                        </div>
                        <div className="card-stat-item demand">
                            <FiTrendingUp />
                            <span><strong>High</strong> Demand</span>
                        </div>
                    </div>

                    <div className="price-section">
                        <div>
                            <p className="price-label">Best Price</p>
                            <p className="price-value">₹500</p>
                        </div>
                        <button className="btn btn-secondary edit-btn" onClick={handleEditPriceClick}>
                            <FiEdit2 /> Edit
                        </button>
                    </div>

                    <div className="sub-services-section">
                        <p className="sub-services-label">Sub-Services</p>
                        <div className="pills-container">
                            <span className="pill">Plumbing</span>
                            <span className="pill">Tap Installation</span>
                            <span className="pill">Toilet Repair</span>
                            <span className="pill">Drainage Cleaning</span>
                            <button className="btn-add-pill"><FiPlus /> Add Services</button>
                        </div>
                    </div>
                </article>

                {/* Service Card: Electrician */}
                <article className="service-card">
                    <div className="card-header">
                        <div className="service-title">
                            <FiZap />
                            <h2>Electrician</h2>
                        </div>
                        <div className="toggle-switch">
                            <input 
                                type="checkbox" 
                                id="electrician-toggle" 
                                className="toggle-input" 
                                checked={isElectricianActive}
                                onChange={() => handleToggle('electrician', isElectricianActive, setIsElectricianActive)}
                            />
                            <label htmlFor="electrician-toggle" className="toggle-label"></label>
                        </div>
                    </div>

                    <div className="card-stats">
                        <div className="card-stat-item">
                           <FiStar />
                            <span><strong>4.9</strong> Rating</span>
                        </div>
                        <div className="card-stat-item">
                           <FiUsers />
                            <span><strong>62</strong> Job Done</span>
                        </div>
                        <div className="card-stat-item demand">
                           <FiTrendingUp />
                            <span><strong>High</strong> Demand</span>
                        </div>
                    </div>

                    <div className="price-section">
                        <div>
                            <p className="price-label">Starting Price</p>
                            <p className="price-value">₹450</p>
                        </div>
                        <button className="btn btn-secondary edit-btn" onClick={handleEditPriceClick}>
                            <FiEdit2 /> Edit
                        </button>
                    </div>

                    <div className="sub-services-section">
                        <p className="sub-services-label">Sub-Services</p>
                        <div className="pills-container">
                            <span className="pill">Wiring</span>
                            <span className="pill">Fan Installation</span>
                            <button className="btn-add-pill"><FiPlus /> Add Services</button>
                        </div>
                    </div>
                </article>

                {/* Add New Service Card */}
                <div className="add-new-card">
                    <div className="add-icon-wrapper">
                        <FiPlus />
                    </div>
                    <h3>Add New Service</h3>
                    <p>Expand your offerings and increase your earning potential.</p>
                    <button className="btn btn-primary" onClick={handleBrowseServicesClick}>
                        Browse Available Services
                    </button>
                </div>
            </main>
        </div>
    );
};

export default MyServices;
